import React, { useState, useEffect } from "react";
import MiniCalendar from "./components/MiniCalendar";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import BuildingContextSelector from "./components/BuildingContextSelector";
import { useHistory } from "react-router-dom";
import { functions } from "../../constants/common-functions";

export default function RoomBooking() {
	
	useEffect(() => {
		
		 functions.redirectDemoUser(history);
	  }, []);

  const [floorplanVisible, setFloorplanVisible] = useState(false);
  const [desks, setDesks] = useState([]);
  const [adminMode, setAdminMode] = useState(false);

  const [startPoint, setStartPoint] = useState(null);
  const [clickMeta, setClickMeta] = useState(null);

  const [selectedDate, setSelectedDate] = useState(new Date());
  const [selectedTime, setSelectedTime] = useState(null);
  
  const [timeStart, setTimeStart] = useState(null);
  const [timeEnd, setTimeEnd] = useState(null);
  
  const [deskOccupancy, setDeskOccupancy] = useState({});
  
  const [selectedDesk, setSelectedDesk] = useState(null);
  const [showDeskPopup, setShowDeskPopup] = useState(false);
  const [surveyMode, setSurveyMode] = useState(false);
  const [selectedSurveyAction, setSelectedSurveyAction] = useState(null);
  
  const [deskName, setDeskName] = useState("");
  const [deskWidth, setDeskWidth] = useState("");
  const [deskHeight, setDeskHeight] = useState("");
  const [assignedPerson, setAssignedPerson] = useState("");
  
  const peopleList = [
    { id: 1, name: "Jane Smith" },
    { id: 2, name: "Mark Turner" },
    { id: 3, name: "Aisha Khan" },
    { id: 4, name: "Tom Reynolds" }
  ];

  
  const history = useHistory();

    const navigateToFloor = (floor) => {
      history.push({
        pathname: "/roombooking/floor/" + floor.id,
        state: {
          building: building,
          floor: floor
        }
      });
    };

    const navigateBackToCampus = () => {
      history.push("/roombooking/navigator");
    };
  

  useEffect(() => {
    const img = new Image();
    img.src = "/roombooking/floorplan.png";
    img.onload = () => {
      setTimeout(() => setFloorplanVisible(true), 1000);
    };
  }, []);
  
  function refreshDeskOccupancy() {
    const newOccupancy = {};
    staticSvgDesks.forEach((d, idx) => {
      newOccupancy[idx] = Math.random() > 0.5;
    });
    setDeskOccupancy(newOccupancy);
  }
  
  function handleDeskClick(desk, occupied, index) {
     setSelectedDesk({
       ...desk,
       index,
       occupied,
       code: `D-${index + 1}`,
	   surveyMode: surveyMode
     });
     setShowDeskPopup(true);
   }

  const SVG_WIDTH = 9933;
  const SVG_HEIGHT = 7016;

  const MIN_RECT_SIZE = 30;
  const CLICK_MOVE_THRESHOLD = 6;
  const CLICK_TIME_THRESHOLD = 250;
  
  const building = {
    name: "North Wing",
    location: "Leeds",
    image: "/roombooking/building1.jpg"
  };

  const floors = [
    { name: "Ground Floor", desks: 48, occupancy: 42 },
    { name: "Level 1", desks: 64, occupancy: 58 },
    { name: "Level 2", desks: 72, occupancy: 71 },
    { name: "Level 3", desks: 60, occupancy: 36 },
    { name: "Level 4", desks: 54, occupancy: 81 }
  ];
  
  function handleTimeSelect(time) {
	if (!timeStart || (timeStart && timeEnd)) {
	    setTimeStart(time);
	    setTimeEnd(null);
	  } else if (!timeEnd) {
	    if (time > timeStart) {
	      setTimeEnd(time);
	    } else {
	      // clicked earlier than start – reset start
	      setTimeStart(time);
	      setTimeEnd(null);
	    }
	  }
    refreshDeskOccupancy();
  }
  
  function isTimeInRange(t) {
    if (!timeStart) return false;
    if (timeStart && !timeEnd) return t === timeStart;
    return t >= timeStart && t <= timeEnd;
  }

  // 👇 Static desks from your SVG
  const staticSvgDesks = [
    { x:1323, y:733, width:188, height:92 },
    { x:1526, y:733, width:181, height:92 },
    { x:1326, y:831, width:183, height:85 },
    { x:1526, y:840, width:179, height:79 },
    { x:1513, y:1150, width:185, height:87 },
    { x:1894, y:554, width:90, height:177 },
    { x:2001, y:556, width:81, height:173 },
    { x:1890, y:744, width:92, height:187 },
    { x:1998, y:746, width:88, height:181 },
    { x:1609, y:1246, width:90, height:177 },
    { x:1507, y:1248, width:94, height:183 },
    { x:2263, y:1294, width:92, height:185 },
    { x:2255, y:1583, width:88, height:187 },
    { x:2255, y:1825, width:85, height:181 },
    { x:2363, y:1458, width:96, height:187 },
    { x:2359, y:1700, width:98, height:185 },
    { x:2363, y:1944, width:96, height:185 },
    { x:2259, y:2063, width:90, height:183 }
  ];

  // 🔄 Re-randomise desk colours only when DATE changes
  useEffect(() => {
   refreshDeskOccupancy();
  }, [selectedDate]);

  function getSvgCoords(evt, svg) {
    const rect = svg.getBoundingClientRect();
    const scaleX = SVG_WIDTH / rect.width;
    const scaleY = SVG_HEIGHT / rect.height;
    return {
      x: (evt.clientX - rect.left) * scaleX,
      y: (evt.clientY - rect.top) * scaleY
    };
  }

  function handleMouseDown(e) {
    if (!adminMode) return;
    setClickMeta({
      x: e.clientX,
      y: e.clientY,
      time: Date.now()
    });
  }

  function handleMouseUp(e) {
    if (!adminMode || !clickMeta) return;

    const dx = Math.abs(e.clientX - clickMeta.x);
    const dy = Math.abs(e.clientY - clickMeta.y);
    const dt = Date.now() - clickMeta.time;
    setClickMeta(null);

    if (dx > CLICK_MOVE_THRESHOLD || dy > CLICK_MOVE_THRESHOLD || dt > CLICK_TIME_THRESHOLD) return;

    const svg = e.currentTarget;
    const point = getSvgCoords(e, svg);

    if (!startPoint) {
      setStartPoint(point);
      return;
    }

    const x = Math.min(startPoint.x, point.x);
    const y = Math.min(startPoint.y, point.y);
    const width = Math.abs(point.x - startPoint.x);
    const height = Math.abs(point.y - startPoint.y);
    setStartPoint(null);

    if (width < MIN_RECT_SIZE || height < MIN_RECT_SIZE) return;

    setDesks(prev => [...prev, { id: Date.now(), x, y, width, height }]);
  }

  function undoLastDesk() {
    setDesks(prev => prev.slice(0, -1));
  }


  function generateSvgText() {
    let svg =
`<svg width="${SVG_WIDTH}" height="${SVG_HEIGHT}" viewBox="0 0 ${SVG_WIDTH} ${SVG_HEIGHT}" xmlns="http://www.w3.org/2000/svg">\n`;

    desks.forEach(d => {
      svg +=
`  <rect x="${Math.round(d.x)}" y="${Math.round(d.y)}" width="${Math.round(d.width)}" height="${Math.round(d.height)}" rx="4" ry="4" fill="rgba(255,165,0,0.35)" stroke="#ff9f1c" stroke-width="3"/>\n`;
    });

    svg += `</svg>`;
    return svg;
  }

  const FLOORPLAN_WIDTH = 9933;
  const FLOORPLAN_HEIGHT = 7016;
  const initialScale = 0.12;

  const mainContainer = {
    display: "flex",
    flexWrap: "wrap",
    width: "100%",
    height: "100vh",
    backgroundColor: "white"
  };

  const header = {
    display: "flex",
    width: "100%",
    height: "80px",
    alignItems: "center"
  };

  const logoStyle = {
    marginLeft: "20px",
    width: "200px"
  };

  const leftPanel = {
    display: "flex",
    backgroundColor: "black",
    marginLeft: "40px",
    marginRight: "20px",
    height: "calc(100% - 170px)",
    width: "calc(50% - 100px)",
    marginBottom: "40px",
    border: "20px solid black",
    position: "relative"
  };

  const rightPanel = {
    display: "flex",
    position: "relative",
    backgroundColor: "#111",
    marginLeft: "20px",
    marginRight: "40px",
    height: "calc(100% - 130px)",
    width: "calc(50% - 60px)",
    overflow: "hidden"
  };

  const floorplanFadeStyle = {
    opacity: floorplanVisible ? 1 : 0,
    transition: "opacity 1.5s ease-in-out",
    width: "100%",
    height: "100%"
  };

  const controlBtn = {
    padding: "10px 14px",
    borderRadius: "10px",
    border: "none",
    background: "#0FA4A9",
    color: "white",
    cursor: "pointer",
    fontWeight: 600
  };

  const controlBtnDanger = {
    ...controlBtn,
    background: "#ff5c5c"
  };
  
  const surveyBtn = {
    background: "rgba(255,255,255,0.12)",
    border: "1px solid rgba(255,255,255,0.2)",
    color: "#fff",
    borderRadius: "10px",
    padding: "10px",
    cursor: "pointer",
    fontWeight: 600,
    transition: "background 0.2s ease"
  };
  
  function getBookingDescription() {
    if (!selectedTime && !timeStart) return null;

    const name = "Roy Bleeks";
    const dateStr = selectedDate.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric"
    });

    const start = timeStart || selectedTime;
    const end = timeEnd || "17:00";

    return `Booked by ${name} on ${dateStr} between ${start} and ${end}`;
  }

  const renderDesks = adminMode ? desks : staticSvgDesks;
  
  const surveyInputStyle = {
    padding: "10px 12px",
    borderRadius: "10px",
    border: "1px solid rgba(255,255,255,0.25)",
    background: "rgba(255,255,255,0.08)",
    color: "#fff",
    fontSize: "13px",
    outline: "none"
  };


  return (
    <>
      <div style={mainContainer}>
        <div style={header}>
          <img src="/roombooking/logo.png" style={logoStyle} alt="Diamond" />

          <button
            onClick={() => {
				setAdminMode(!adminMode);
				setSurveyMode(false);
			}}
            style={{
              marginLeft: "20px",
              padding: "8px 14px",
              borderRadius: "10px",
              border: "none",
              background: adminMode ? "#ff9f1c" : "#0FA4A9",
              color: "white",
              cursor: "pointer",
              fontWeight: 600
            }}
          >
            {adminMode ? "Exit Admin" : "Admin Mode"}
          </button>
		  <button
		    onClick={() => {
		      setSurveyMode(!surveyMode);
		      setAdminMode(false);
		    }}
		    style={{
		      marginLeft: "12px",
		      padding: "8px 14px",
		      borderRadius: "10px",
		      border: "none",
		      background: surveyMode ? "#8e44ad" : "#34495e",
		      color: "white",
		      cursor: "pointer",
		      fontWeight: 600
		    }}
		  >
		    {surveyMode ? "Exit Survey" : "Survey Mode"}
		  </button>

        </div>

        {/* LEFT PANEL */}
        <div style={leftPanel}>
          {adminMode && startPoint && (
            <div style={{
              position: "absolute",
              top: "20px",
              left: "20px",
              background: "#0FA4A9",
              color: "white",
              padding: "8px 14px",
              borderRadius: "12px",
              zIndex: 10
            }}>
              Select bottom-right corner…
            </div>
          )}

          <div style={floorplanFadeStyle}>
            <TransformWrapper
              initialScale={initialScale}
              minScale={0.08}
              maxScale={4}
              wheel={{ step: 0.15 }}
              pinch={{ step: 5 }}
              doubleClick={{ disabled: true }}
              centerOnInit
            >
              <TransformComponent
                wrapperStyle={{ width: "100%", height: "100%" }}
                contentStyle={{
                  width: FLOORPLAN_WIDTH,
                  height: FLOORPLAN_HEIGHT
                }}
              >
                <svg
                  width={SVG_WIDTH}
                  height={SVG_HEIGHT}
                  style={{ display: "block", cursor: adminMode ? "crosshair" : "pointer" }}
                  onMouseDown={handleMouseDown}
                  onMouseUp={handleMouseUp}
                >
                  <image
                    href="/roombooking/floorplan.png"
                    x="0"
                    y="0"
                    width={SVG_WIDTH}
                    height={SVG_HEIGHT}
                    preserveAspectRatio="none"
					style={{ pointerEvents: "none" }}
                  />

                  {adminMode && startPoint && (
                    <rect
                      x={startPoint.x - 6}
                      y={startPoint.y - 6}
                      width="12"
                      height="12"
                      fill="#0FA4A9"
                      rx="2"
                      ry="2"
                    />
                  )}

                  {renderDesks.map((d, idx) => {
                    const occupied = !adminMode && deskOccupancy[idx];

                    return (
                      <rect
					    onClick={() => !adminMode && handleDeskClick(d, occupied, idx)}
                        key={idx}
                        x={d.x}
                        y={d.y}
                        width={d.width}
                        height={d.height}
                        rx="4"
                        ry="4"
                        fill={
                          adminMode
                            ? "rgba(255,165,0,0.25)"
                            : occupied
                              ? "rgba(255,0,0,0.5)"
                              : "rgba(0,200,0,0.5)"
                        }
                        stroke={
                          adminMode
                            ? "#ff9f1c"
                            : occupied
                              ? "#cc0000"
                              : "#008800"
                        }
                        strokeWidth="3"
                        style={{ cursor: adminMode ? "crosshair" : "pointer", pointerEvents: "all", transition: 'fill 0.25s ease, stroke 0.25s ease' }}
						onPointerDown={(e) => {
						    e.stopPropagation();
						    if (!adminMode) {
						      handleDeskClick(d, occupied, idx);
						    }
						  }}
                      />
                    );
                  })}
                </svg>
              </TransformComponent>
            </TransformWrapper>
          </div>
        </div>

        {/* RIGHT PANEL */}
        <div style={rightPanel}>
          <iframe
            title="Virtual Tour"
            src="https://tour.giraffe360.com/addd9e3d5b1f47e1b82bb64c672baf16/"
            style={{ width: "100%", height: "100%", border: "none" }}
          />

          {adminMode && (
            <div style={{
              position: "absolute",
              top: "20px",
              right: "20px",
              width: "380px",
              height: "360px",
              background: "#000",
              borderRadius: "12px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.45)",
              padding: "14px",
              display: "flex",
              flexDirection: "column",
              zIndex: 20,
              fontFamily: "monospace"
            }}>
              <div style={{ color: "#0FA4A9", fontWeight: 600, marginBottom: "8px" }}>
                Generated SVG
              </div>

              <textarea
                value={generateSvgText()}
                readOnly
                style={{
                  flex: 1,
                  width: "100%",
                  background: "#050505",
                  color: "#0FA4A9",
                  border: "1px solid #333",
                  borderRadius: "6px",
                  padding: "10px",
                  resize: "none",
                  fontSize: "11px",
                  lineHeight: "1.4"
                }}
              />

              <div style={{ display: "flex", gap: "8px", marginTop: "10px" }}>
                <button onClick={() => navigator.clipboard.writeText(generateSvgText())} style={controlBtn}>Copy</button>
                <button onClick={undoLastDesk} style={controlBtn}>Undo</button>
                <button onClick={() => setDesks([])} style={controlBtnDanger}>Clear</button>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Calendar swoosh */}
      <div style={{
        position: "fixed",
        bottom: "0px",
        left: "0px",
        width: "420px",
        height: "280px",
        background: "#1f2b44",
        color: "#ffffff",
        boxShadow: "0 12px 30px rgba(0,0,0,0.18)",
        borderTopRightRadius: "180px 140px",
        borderBottomRightRadius: "80px 120px",
        borderTopLeftRadius: "24px",
        borderBottomLeftRadius: "24px",
        zIndex: 50
      }}>
        <div style={{ padding: "36px 40px 32px 32px" }}>
          <div style={{ color: "#ff9f1c", fontSize: "18px", marginBottom: "12px", fontWeight: 600 }}>
            Book a Desk
          </div>
          <MiniCalendar onDateChange={setSelectedDate} />
        </div>
      </div>

      {/* Time Ribbon */}
      <div style={{
        position: "fixed",
        bottom: "10px",
        left: "380px",
        height: "82px",
        width: "880px",
        background: "#0FA4A9",
        boxShadow: "0 16px 36px rgba(0,0,0,0.25)",
        zIndex: 40,
        borderTopLeftRadius: "180px 120px",
        borderBottomLeftRadius: "56px 56px",
        borderTopRightRadius: "32px",
        borderBottomRightRadius: "32px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        padding: "12px 28px"
      }}>
	  <div style={{ display: "flex", marginBottom: "8px", marginLeft: "90px" }}>
	    {["08:00","09:00","10:00","11:00","12:00","13:00","14:00","15:00","16:00","17:00","18:00"].map(t => (
	      <div
	        key={t}
	        onClick={() => handleTimeSelect(t)}
	        style={{
	          color: "#ffffff",
	          fontSize: "14px",
	          padding: "6px 12px",
	          marginRight: "8px",
	          borderRadius: "14px",
	          cursor: "pointer",
			  background: isTimeInRange(t)
			    ? "rgba(0,150,90,0.85)"   // dark green active range
			    : "rgba(255,255,255,0.18)",
			  fontWeight: isTimeInRange(t) ? 600 : 400,
	          transition: "all 0.2s ease"
	        }}
	      >
	        {t}
	      </div>
	    ))}
	  </div>


	  <div style={{ display: "flex", marginLeft: "90px" }}>
	    {["08:30","09:30","10:30","11:30","12:30","13:30","14:30","15:30","16:30","17:30","18:30"].map(t => (
	      <div
	        key={t}
	        onClick={() => handleTimeSelect(t)}
	        style={{
	          color: "#ffffff",
	          fontSize: "14px",
	          padding: "6px 12px",
	          marginRight: "8px",
	          borderRadius: "14px",
	          cursor: "pointer",
			  background: isTimeInRange(t)
			    ? "rgba(0,150,90,0.85)"   // dark green active range
			    : "rgba(255,255,255,0.18)",
			  fontWeight: isTimeInRange(t) ? 600 : 400,
	          transition: "all 0.2s ease"
	        }}
	      >
	        {t}
	      </div>
	    ))}
	  </div>
	  </div>
	  {showDeskPopup && selectedDesk && (
	    <div style={{
	      position: "fixed",
	      top: "50%",
	      left: "50%",
	      transform: "translate(-50%, -50%)",
	      width: "420px",
	      background: "#1f2b44",
	      borderRadius: "18px",
	      boxShadow: "0 20px 60px rgba(0,0,0,0.45)",
	      zIndex: 200,
	      overflow: "hidden"
	    }}>

	      {/* Header */}
	      <div style={{
	        padding: "16px 20px",
	        background: surveyMode ? "#8e44ad" : (selectedDesk.occupied ? "#c0392b" : "#0FA4A9"),
	        color: "#fff",
	        fontWeight: 600,
	        fontSize: "16px",
	        display: "flex",
	        justifyContent: "space-between",
	        alignItems: "center"
	      }}>
	        <div>{selectedDesk.code}</div>
	        <div style={{ fontSize: "13px", opacity: 0.9 }}>
	          {surveyMode
	            ? "Survey Mode"
	            : selectedDesk.occupied
	              ? "Currently Occupied"
	              : "Available"}
	        </div>
	      </div>

	      {/* Body */}
	      <div style={{ padding: "18px", color: "#fff" }}>

	        {/* NORMAL BOOKING MODE */}
	        {!surveyMode && (
	          <>
	            <div style={{ marginBottom: "12px", fontSize: "13px", opacity: 0.85 }}>
	              Desk availability
	            </div>

	            <MiniCalendar />

	            <div style={{
	              marginTop: "12px",
	              padding: "10px",
	              borderRadius: "10px",
	              background: "rgba(255,255,255,0.08)",
	              fontSize: "13px"
	            }}>
	              {selectedDesk.occupied
	                ? "This desk is currently in use at the selected time!  " + getBookingDescription()
	                : "This desk is available and can be booked."
	              }
	            </div>
	          </>
	        )}

	        {/* SURVEY MODE */}
			{surveyMode && (
			  <>
			    <div style={{
			      marginBottom: "14px",
			      fontSize: "14px",
			      fontWeight: 600,
			      color: "#0FA4A9"
			    }}>
			      Survey Observation
			    </div>

			    {/* Status Buttons */}
			    <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
			      {[
			        { key: "NO_SHOW", label: "No Show" },
			        { key: "USED_AS_BOOKED", label: "Used as Booked" },
			        { key: "SIGNS_OF_LIFE", label: "Signs of Life" }
			      ].map(opt => (
			        <button
			          key={opt.key}
			          onClick={() => setSelectedSurveyAction(opt.key)}
			          style={{
			            padding: "10px",
			            borderRadius: "10px",
			            border: "1px solid rgba(255,255,255,0.25)",
			            cursor: "pointer",
			            fontWeight: 600,
			            color: "#fff",
			            background: selectedSurveyAction === opt.key
			              ? "linear-gradient(135deg, #8e44ad, #6c3483)"
			              : "rgba(255,255,255,0.12)",
			            boxShadow: selectedSurveyAction === opt.key
			              ? "0 0 0 2px rgba(142,68,173,0.6)"
			              : "none",
			            transition: "all 0.2s ease"
			          }}
			        >
			          {opt.label}
			        </button>
			      ))}
			    </div>

			    {/* Desk Metadata */}
			    <div style={{ marginTop: "16px", display: "flex", flexDirection: "column", gap: "10px" }}>
				{/* Desk Name */}
			      <input
			        placeholder="Desk Code"
			        value={deskName}
			        onChange={(e) => setDeskName(e.target.value)}
			        style={surveyInputStyle}
			      />
			      {/* Desk Name */}
			      <input
			        placeholder="Desk Name / Description"
			        value={deskName}
			        onChange={(e) => setDeskName(e.target.value)}
			        style={surveyInputStyle}
			      />

			      {/* Dimensions */}
			      <div style={{ display: "flex", gap: "10px" }}>
			        <input
			          placeholder="Width (cm)"
			          value={deskWidth}
			          onChange={(e) => setDeskWidth(e.target.value)}
			          style={surveyInputStyle}
			        />
			        <input
			          placeholder="Height (cm)"
			          value={deskHeight}
			          onChange={(e) => setDeskHeight(e.target.value)}
			          style={surveyInputStyle}
			        />
			      </div>

			      {/* Assign Person */}
			      <select
			        value={assignedPerson}
			        onChange={(e) => setAssignedPerson(e.target.value)}
			        style={surveyInputStyle}
			      >
			        <option value="">Assign to person…</option>
			        {peopleList.map(p => (
			          <option key={p.id} value={p.name}>{p.name}</option>
			        ))}
			      </select>

			    </div>

			    <div style={{ marginTop: "14px", fontSize: "12px", opacity: 0.7 }}>
			      Capture desk attributes and ownership during survey.
			    </div>
			  </>
			)}

	      </div>

	      {/* Footer */}
	      <div style={{
	        padding: "14px 18px",
	        display: "flex",
	        justifyContent: "space-between",
	        background: "#182033"
	      }}>
	        <button
	          onClick={() => setShowDeskPopup(false)}
	          style={{
	            background: "transparent",
	            border: "1px solid rgba(255,255,255,0.3)",
	            color: "#fff",
	            borderRadius: "10px",
	            padding: "8px 14px",
	            cursor: "pointer"
	          }}
	        >
	          Close
	        </button>

	        {!surveyMode && !selectedDesk.occupied && (
	          <button
	            style={{
	              background: "#0FA4A9",
	              border: "none",
	              color: "#fff",
	              borderRadius: "10px",
	              padding: "8px 16px",
	              cursor: "pointer",
	              fontWeight: 600
	            }}
	          >
	            Book Desk
	          </button>
	        )}
	      </div>
	    </div>
	  )}
	  <BuildingContextSelector
	    building={building}
	    floors={floors}
	    onFloorSelect={(floor) => navigateToFloor(floor)}
	    onBackToCampus={() => history.push("/roombooking/navigator")}
	  />

    </>
  );
}
